import { type CreateMaintenanceInstallationRequest } from '@gb-ticket/shared-types';
import { Controller, useFormContext } from 'react-hook-form';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

function FieldError({ message }: { message?: string }) {
  if (!message) {
    return null;
  }
  return (
    <p className="text-sm text-destructive" role="alert">
      {message}
    </p>
  );
}

export function MaintenanceInstallationIdentityFields() {
  const { register, control, formState } = useFormContext<CreateMaintenanceInstallationRequest>();
  const errors = formState.errors;

  return (
    <div className="space-y-4">
      <h2 className="text-base font-semibold">Anlage</h2>
      <div className="space-y-2">
        <Label htmlFor="inst-no">Anlagenkennung</Label>
        <Input id="inst-no" className="min-h-11" {...register('installationNumber')} />
        <FieldError message={errors.installationNumber?.message} />
      </div>
      <div className="space-y-2">
        <Label htmlFor="inst-name">Bezeichnung</Label>
        <Input id="inst-name" className="min-h-11" {...register('name')} />
        <FieldError message={errors.name?.message} />
      </div>
      <div className="space-y-2">
        <Label htmlFor="inst-type">Anlagentyp</Label>
        <Input id="inst-type" className="min-h-11" {...register('installationType')} />
        <FieldError message={errors.installationType?.message} />
      </div>
      <div className="space-y-2">
        <Label htmlFor="inst-loc">Standort</Label>
        <Input id="inst-loc" className="min-h-11" {...register('location')} />
        <FieldError message={errors.location?.message} />
      </div>
      <div className="flex items-center justify-between gap-3">
        <Label htmlFor="inst-active">Aktiv</Label>
        <Controller
          name="isActive"
          control={control}
          render={({ field }) => (
            <Switch
              id="inst-active"
              checked={field.value}
              onCheckedChange={field.onChange}
              aria-label="Anlage ist aktiv"
            />
          )}
        />
      </div>
    </div>
  );
}

export function MaintenanceInstallationTechnicalFields() {
  const { register, formState } = useFormContext<CreateMaintenanceInstallationRequest>();
  const errors = formState.errors;

  return (
    <div className="space-y-4">
      <h2 className="text-base font-semibold">Technische Daten</h2>
      <div className="space-y-2">
        <Label htmlFor="inst-manufacturer">Hersteller (optional)</Label>
        <Input id="inst-manufacturer" className="min-h-11" {...register('manufacturer')} />
        <FieldError message={errors.manufacturer?.message} />
      </div>
      <div className="space-y-2">
        <Label htmlFor="inst-model">Modell (optional)</Label>
        <Input id="inst-model" className="min-h-11" {...register('model')} />
        <FieldError message={errors.model?.message} />
      </div>
      <div className="space-y-2">
        <Label htmlFor="inst-serial">Seriennummer (optional)</Label>
        <Input id="inst-serial" className="min-h-11" {...register('serialNumber')} />
        <FieldError message={errors.serialNumber?.message} />
      </div>
      <div className="space-y-2">
        <Label htmlFor="inst-commissioned">Inbetriebnahme (optional)</Label>
        <Input
          id="inst-commissioned"
          type="date"
          className="min-h-11"
          {...register('commissionedOn')}
        />
        <FieldError message={errors.commissionedOn?.message} />
      </div>
    </div>
  );
}
